export default __webpack_public_path__ + "static/media/frontapp.353d7532.svg";